module.exports = __webpack_public_path__ + "static/pod-intro-img-mobile-3-a74fbd3de89c9b6132d2bbc622df8fd8.png";